import React, { FC, ReactNode } from 'react';
import { JCBLogo } from 'src/atoms/card_brands/JCBLogo';
import { DiscoverLogo } from 'src/atoms/card_brands/DiscoverLogo';
import { VisaLogo } from 'src/atoms/card_brands/VisaLogo';
import { MasterCardLogo } from 'src/atoms/card_brands/MasterCardLogo';
import { AmexLogo } from 'src/atoms/card_brands/AmexLogo';
import { DinersLogo } from 'src/atoms/card_brands/DinersLogo';

type LogoWrapperProps = {
  children: ReactNode;
};

const LogoWrapper: FC<LogoWrapperProps> = ({ children }) => {
  return (
    <div className="flex h-7 flex-shrink-0 items-center justify-center border border-gray-200 bg-white px-1 py-0.5 sm:w-auto [&>svg]:h-4 [&>svg]:w-auto">
      {children}
    </div>
  );
};

// UI上のちらつき防止のために、表示するIconがない場合はあらかじめplaceHolderを置いて、アイコンが置かれた場合でもUIにズレがないようにする
const ICON_PLACE_HOLDER = () => <div className="h-[32px] w-[32px]" />;

const VMBrands = () => {
  return (
    <>
      <LogoWrapper>
        <VisaLogo />
      </LogoWrapper>
      <LogoWrapper>
        <MasterCardLogo />
      </LogoWrapper>
    </>
  );
};

const JADDBrands = () => {
  return (
    <>
      <LogoWrapper>
        <JCBLogo />
      </LogoWrapper>
      <LogoWrapper>
        <AmexLogo />
      </LogoWrapper>
      <LogoWrapper>
        <DinersLogo />
      </LogoWrapper>
      <LogoWrapper>
        <DiscoverLogo />
      </LogoWrapper>
    </>
  );
};

type Props = {
  isVmAvailable: boolean;
  isJaddAvailable: boolean;
};

export const MulpayAvailableBrandList: FC<Props> = ({
  isVmAvailable,
  isJaddAvailable,
}) => {
  return (
    <div className="rounded-10 mx-2 mb-2 bg-gray-50 p-2">
      <p className="mt-0 text-[12px] font-medium text-gray-400">
        ご利用可能カード
      </p>

      <div className="rounded-10 mx-3 bg-white shadow-sm">
        <div className="flex items-center justify-center gap-1">
          {isVmAvailable && <VMBrands />}
          {isJaddAvailable && <JADDBrands />}
          {/*  利用可能なブランドがない場合はplaceHolderを設置している */}
          {!isVmAvailable && !isJaddAvailable && <ICON_PLACE_HOLDER />}
        </div>
      </div>
    </div>
  );
};
